import "../../Styles/General & MultiUse/Footer.css";
import Facebook from "../../Assets/Facebook.png";
import Instagram from "../../Assets/Instagram.png";
import Twitter from "../../Assets/Twitter.png";
import Mail from "../../Assets/Mail.png";
import { useState } from "react";
import axios from "axios";

const Footer = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(email);

    try {
      const response = await axios.post("https://your-api-endpoint.com/messages", { email });
      console.log("Email sent successfully:", response.data);
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  function handleEmailChange(e) {
    setEmail(e.target.value);
  }

  return (
    <div className="footer">
      <span>Get in touch with us</span>
      <span>
        <a href="tel:+2349046092319">+2349046092319</a>
      </span>
      <span>
        <a href="https://www.facebook.com/Madrasatuzulaykha?mibextid=ZbWKwL">
          <img src={Facebook} alt="Facebook" />
        </a>
        <a href="https://www.instagram.com/the_zulaykha_global_academy/profilecard/?igsh=ZnRrMWVncWNlM2g0">
          <img src={Instagram} alt="Instagram" />
        </a>
        <a href="https://x.com/Zulaykha_Global?t=iuLzivw13AjDNOXYqzbpaw&s=09">
          <img src={Twitter} alt="Twitter/X" />
        </a>
      </span>
      <span>
        <a href="mailto:madrasahzulaykha@gmail.com">
          <img src={Mail} alt="Mail" />
          madrasahzulaykha@gmail.com
        </a>
      </span>
      <form>
        <input type="email" name="email" placeholder="Email address" required onChange={handleEmailChange} />
        <input type="submit" value="Send" onClick={handleSubmit} />
      </form>
    </div>
  );
};

export default Footer;
